import { THE_BIG_DESCRIPTOR } from "./sdedescriptors";

export type { SDEScrapingParameters } from "./types";
import type { SDEScrapingParameters } from "./types";

export const getSDEParamsForAsyncEndpoint = (urlPath: string): SDEScrapingParameters | undefined =>
  THE_BIG_DESCRIPTOR.find(descriptor => descriptor.asyncEndpoint === urlPath);

export const getSDEParamsForAsyncType = (type: string): SDEScrapingParameters | undefined =>
  THE_BIG_DESCRIPTOR.find(descriptor => descriptor.asyncType === type);

export const getSDEParamsForHostedScraperType = (type: string): SDEScrapingParameters | undefined =>
  THE_BIG_DESCRIPTOR.find(descriptor => descriptor.hostedScraperType === type);

export const getSDEParamsForPublicHostedScraperAPIType = (type: string): SDEScrapingParameters | undefined =>
  THE_BIG_DESCRIPTOR.find(descriptor => descriptor.publicHostedScraperAPIType === type);

export const getValidDatapipelineProjectTypes = (): string[] => THE_BIG_DESCRIPTOR.map(descriptor => descriptor.publicHostedScraperAPIType);